module.exports = "/_next/static/images/loading_13-b7f46219624610d1683c3c07344733e6.png";